import ScheduleCreateCategoriesModal from './modals/ScheduleCreateCategoriesModal';
import ScheduleCreateItemsModal from './modals/ScheduleCreateItemsModal';
import ScheduleCreateBulkModal from './modals/ScheduleCreateBulkModal';
import ScheduleCreateDeleteCategoryModal from './modals/ScheduleCreateDeleteCategoryModal';
import ScheduleCreateDeleteItemsModal from './modals/ScheduleCreateDeleteItemsModal';
import MessagesSnackbar from '../../../components/shared/MessagesSnackbar';
import { useContext } from 'react';
import { ScheduleCreateContext, ScheduleCreateValues } from '../contexts/ScheduleCreateContext';
import ScheduleCreateDeleteScheduleModal from './modals/ScheduleCreateDeleteScheduleModal';
import LeavePageWithoutSaveModal from '../../../components/shared/dialogs/LeavePageWithoutSaveModal';
import ScheduleCreateCountZonesModal from './modals/ScheduleCreateCountZonesModal';
import ScheduleCreateCountZoneTypesModal from './modals/ScheduleCreateCountZoneTypesModal';
import ScheduleCreateDeleteCountZonesModal from './modals/ScheduleCreateDeleteCountZonesModal';
import ScheduleCreateDeleteCountZoneTypesModal from './modals/ScheduleCreateDeleteCountZoneTypesModal';
import ScheduleCreateViewItemsOfCountZone from './modals/ScheduleCreateViewItemsOfCountZones';
import ScheduleCreateProductTypesModal from './modals/ScheduleCreateProductTypesModal';
import ScheduleCreateDeleteProductTypeModal from './modals/ScheduleCreateDeleteProductTypeModal';

const ScheduleCreatePopUps = () => {
  const { closeSnackBar,
    isSnackBarOpen,
    snackBarSeverity,
    snackbarMessage,
    snackBarDuration,
    blocker,
    isProductTypeModalOpen,
    handleLeavePageModalClose,
    handleLeavePageModalConfirm } = useContext(ScheduleCreateContext) as ScheduleCreateValues;

  return (
    <>
      <ScheduleCreateCountZoneTypesModal />
      <ScheduleCreateCountZonesModal />
      <ScheduleCreateViewItemsOfCountZone/>
      <ScheduleCreateCategoriesModal />
      {isProductTypeModalOpen && <ScheduleCreateProductTypesModal />}
      <ScheduleCreateItemsModal />
      <ScheduleCreateBulkModal />
      <ScheduleCreateDeleteCategoryModal />
      <ScheduleCreateDeleteProductTypeModal />
      <ScheduleCreateDeleteItemsModal />
      <ScheduleCreateDeleteScheduleModal />
      <ScheduleCreateDeleteCountZonesModal />
      <ScheduleCreateDeleteCountZoneTypesModal />
      <LeavePageWithoutSaveModal open={blocker.state === 'blocked'}
        onConfirm={handleLeavePageModalConfirm}
        onClose={handleLeavePageModalClose}
        onConfirmUrl='/store/orders-history' />
      <MessagesSnackbar onClose={closeSnackBar}
        open={isSnackBarOpen}
        severity={snackBarSeverity}
        message={snackbarMessage}
        duration={snackBarDuration} />
    </>
  );
};

export default ScheduleCreatePopUps;